import React from "react";
import { useLang } from "../i18n";

const linkCls = "text-[#B5651D] underline";

function ConsentBox({ id, checked, onChange, children }) {
  return (
    <div className="flex items-start">
      <span className="shrink-0 w-11 h-11 -ml-3 flex items-center justify-center">
        <input id={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
          className="w-5 h-5 accent-[#3F6E85] cursor-pointer" data-testid={id} />
      </span>
      <label htmlFor={id} className="text-[14px] leading-relaxed text-[#6E6B65] py-2.5 min-h-[44px] cursor-pointer">{children}</label>
    </div>
  );
}

export function ConsentBoxes({ value, onChange, error }) {
  const { t } = useLang();
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-1" data-testid="consent-boxes">
      <ConsentBox id="consent-terms-privacy" checked={value.terms_privacy} onChange={set("terms_privacy")}>
        {t("consent1_pre")}
        <a href="/terms" target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="consent-terms-link">{t("terms_link")}</a>
        {t("consent1_mid")}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="consent-privacy-link">{t("consent1_privacy")}</a>
        {t("consent1_post")}
      </ConsentBox>
      <ConsentBox id="consent-health-data" checked={value.health_data} onChange={set("health_data")}>
        {t("consent2")}
      </ConsentBox>
      {error && <p role="alert" className="text-sm text-[#B7410E]" data-testid="consent-error">{error}</p>}
    </div>
  );
}
